<template>
    <div>
        <!-- 步骤条 -->
        <div class="steps">
            <el-steps direction="vertical" :active="stpsActive" finish-status="success" ref='insideDomRef'>
                <el-step title="Grid Voltage"
                    description="In this step, you will choose the hybrid inverter model."></el-step>
                <el-step title="Load Table" description="Select the desired equipment"></el-step>
                <el-step title="Results" description="Recommended Inverter"></el-step>
            </el-steps>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    props: ['stpsActive'],
    created() {

    }

}
</script>
<style lang="scss" scoped>
::v-deep .steps .el-step .el-step__head {
    padding-bottom: .5rem;
}

::v-deep .steps .el-step .el-step__main {
    padding-bottom: .5rem;
}

::v-deep .steps .el-step .el-step__title {
    color: #282828;
    font-size: 13px;
    font-family: "montserRegular";
    font-weight: 400;
    opacity: .5;
}

::v-deep .steps .el-step__description {
    color: #868686;
    opacity: 0.73;
    font-size: 12px;
    font-family: "montserLight";
}

::v-deep .steps .el-step__line {
    background: #b7b7b7;
    opacity: 0.3;
    width: 1px;
}

::v-deep .steps .el-step__icon {
    background: #d0d0d0;
    color: #ffffff;
    border-color: transparent;
}

// 选中样式
::v-deep .steps .el-step__title.is-success {
    color: #282828;
    opacity: 1;
}

::v-deep .steps .el-step__description.is-success {
    opacity: 1;
}

::v-deep .steps .el-step__head.is-success .el-step__icon {
    background: #e60012;
}

::v-deep .steps .el-step__head.is-success .el-step__line {
    border-color: #e60012;
    opacity: 1;
}
</style>
